import { helper } from "@ember/component/helper";
import dayjs from "dayjs";

export default helper(function (positional, named) {
  return dayjs(positional[0]).fromNow(named.hideAffix || false);
});
